import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';

import { BaseCtrlValueAccessorFormArrayComponent } from '@sim/form';
import { ClassName } from '@sim/role';

@Component({
  selector: 'app-project-form',
  styleUrls: ['./project-form.component.scss'],
  templateUrl: './project-form.component.html',
})
export class ProjectFormComponent  extends BaseCtrlValueAccessorFormArrayComponent<string[]> implements OnDestroy, OnInit {

  @Input() classNames: ClassName[] = [];

  get projects() {
    const form = this.form && this.form.controls;
    return form || [];
  }

  constructor(
  ) {
    super();
  }

  ngOnInit() {
    super.ngOnInit();
  }

  ngOnDestroy() {
    super.ngOnDestroy();
  }

  addHandler() {
    if (!this.form || !this.form.controls) {
      throw new Error('Cannot manage project without a control');
    }

    const projectControl = new UntypedFormControl('');
    this.form.push(projectControl);
  }

  removeHandler(index: number) {
    if (!this.form || !this.form.controls) {
      throw new Error('Cannot manage project without a control');
    }

    this.form.removeAt(index);
  }

}
